
import { FileFolderTableHeadersType } from "./tableHeadersType";

export const FILE_FOLDER_HEADERS: FileFolderTableHeadersType[] = [
  {
    label: 'Client Code',
    value: 'client_code',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Company Name',
    value: 'company',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Total Folders',
    value: 'total_folders',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Total Files',
    value: 'total_files',
    checked: true,
    defaultChecked: true
  }
];